import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../img/logo.svg";
import swal from "sweetalert2";
import { useSpring, animated } from "@react-spring/web";
import { useSecureData } from "../hooks/isLogged";

export default function Layout({ children }) {
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const { data, loading, error } = useSecureData(token);
  const [logged, setLogged] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (data && !loading && !error) {
      setLogged(true);
    } else {
      setLogged(false);
    }
  }, [data, loading, error]);

  const logout = async () => {
    setLogged(false);
    setToken(null);
    localStorage.removeItem("token");
    swal
      .fire({
        title: "Logout Success!",
        icon: "success",
        confirmButtonText: "Close",
        timer: 1000,
      })
      .then(() => {
        navigate("/login");
      });
  };

  const [props, api] = useSpring(
    () => ({
      from: { opacity: 0 },
      to: { opacity: 1 },
    }),
    []
  );

  return (
    <animated.div style={props}>
      <nav className="fixed top-0 left-0 shadow-sm z-20 w-full bg-[#F7F7F7] border-gray-200 border-b">
        <div className="flex flex-wrap items-center justify-between mx-auto px-4 py-2">
          <Link
            to={"/"}
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <Logo />
          </Link>

          <div
            className="hidden w-full lg:flex gap-5 md:w-auto"
            id="navbar-default"
          >
            <Link
              to={logged ? "/create" : "https://web.whatsapp.com"}
              target={logged ? "_self" : "_blank"}
              className="border border-primary text-primary px-6 py-3 rounded-md font-bold transition duration-200 text-sm hover:bg-primary hover:text-white"
            >
              {logged ? "Tambah Item" : "Jual"}
            </Link>

            <button
              className={`bg-primary text-white px-6 py-3 rounded-md font-bold transition duration-200 text-sm hover:opacity-80 ${
                logged ? "block" : "hidden"
              }`}
              onClick={logout}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div>{children}</div>
    </animated.div>
  );
}
